import React from 'react'
import { useSelector } from 'react-redux'
import ZoneIcon from 'components/ZoneIcon'
import { selectAvailableZones } from 'store/global'
import styles from './OrganizationZones.scss'

interface OrganizationZonesProps {
  organization: {
    zoneIds?: string[]
  }
  isColumn?: boolean
}

const OrganizationZones: React.FC<OrganizationZonesProps> = ({ organization, isColumn = false }) => {
  const availableZones = useSelector(selectAvailableZones)

  const { zoneIds = [] } = organization
  if (!zoneIds) return null

  const zoneLabels = zoneIds.map(zoneId => (availableZones.find(({ id }) => id === zoneId) || {}).name)

  if (!isColumn) return <>{zoneLabels.join(', ')}</>

  return (
    <ul className={styles.wrapper}>
      {zoneLabels.map((label, index) => (
        <li key={index} className={styles.zone}>
          <ZoneIcon name={label} className={styles.flag} />
          {label}
        </li>
      ))}
    </ul>
  )
}

export default OrganizationZones

